export const META_AD_CATEGORIES = [
  { id: 'apparel', label: 'Apparel', accent: '#7c6ff2' },
  { id: 'beauty', label: 'Beauty', accent: '#dd6f9f' },
  { id: 'food', label: 'Food & beverage', accent: '#e17c45' },
  { id: 'health', label: 'Health & fitness', accent: '#4e9b72' },
  { id: 'home', label: 'Home & living', accent: '#9c795d' },
  { id: 'saas', label: 'SaaS & AI', accent: '#4c86d9' },
  { id: 'mobile', label: 'Mobile apps', accent: '#8c62c9' },
  { id: 'finance', label: 'Finance', accent: '#4b907d' },
  { id: 'education', label: 'Education', accent: '#c28a31' },
  { id: 'travel', label: 'Travel', accent: '#438ca3' },
];

const BRAND_GROUPS = {
  apparel: [
    ['SKIMS', 'skims.png'], ['Gymshark', 'gymshark.png'], ['Alo Yoga', 'alo.png'],
    ['Lululemon'], ['Nike'], ['Adidas'], ['Vuori'], ['Allbirds', 'allbirds.png'],
    ['On'], ['Abercrombie & Fitch'],
  ],
  beauty: [
    ['Glossier'], ['Rare Beauty'], ['Fenty Beauty'], ['Rhode'], ['CeraVe'],
    ['The Ordinary'], ['e.l.f. Cosmetics'], ['Olaplex'], ['Drunk Elephant'], ['Sephora'],
  ],
  food: [
    ['Huel', 'huel.png'], ['DoorDash', 'doordash.png'], ['HelloFresh'], ['Liquid Death'],
    ['Oatly'], ['Starbucks'], ['Chipotle'], ['Magic Spoon'], ['Graza'], ['LMNT'],
  ],
  health: [
    ['AG1', 'ag1.png'], ['Ritual', 'ritual.png'], ['Noom'], ['WHOOP'], ['Eight Sleep'],
    ['Peloton'], ['Headspace'], ['Calm'], ['BetterHelp'], ['Seed'],
  ],
  home: [
    ['Ruggable'], ['Brooklinen'], ['Parachute'], ['Article'], ['Burrow'],
    ['Saatva'], ['Purple'], ['Dyson'], ['Our Place'], ['Caraway'],
  ],
  saas: [
    ['Perplexity', 'perplexity.png'], ['Notion'], ['Canva'], ['Grammarly'], ['monday.com'],
    ['ClickUp'], ['HubSpot'], ['Webflow'], ['Jasper'], ['Shopify'],
  ],
  mobile: [
    ['Duolingo', 'duolingo.png'], ['Tinder'], ['Bumble'], ['Hinge'], ['Strava'],
    ['Blinkist'], ['Flo'], ['Fabulous'], ['Photomath'], ['CapCut'],
  ],
  finance: [
    ['Kalshi', 'kalshi.png'], ['Revolut'], ['Robinhood'], ['Coinbase'], ['Klarna'],
    ['Chime'], ['SoFi'], ['Wise'], ['Cash App'], ['Ramp'],
  ],
  education: [
    ['MasterClass'], ['Coursera'], ['Udemy'], ['Skillshare'], ['Brilliant'],
    ['Babbel'], ['Rosetta Stone'], ['Quizlet'], ['DataCamp'], ['Headway'],
  ],
  travel: [
    ['Airbnb'], ['Booking.com'], ['Expedia'], ['Hopper'], ['KAYAK'],
    ['Tripadvisor'], ['Vrbo'], ['Skyscanner'], ['GetYourGuide'], ['Omio'],
  ],
};

const CREATIVE_ANGLES = {
  apparel: ['Creator try-on', 'Product proof', 'Seasonal drop'],
  beauty: ['Routine demo', 'Before & after', 'Ingredient story'],
  food: ['Taste reaction', 'Convenience', 'Limited offer'],
  health: ['Habit building', 'Expert proof', 'Member story'],
  home: ['Room transformation', 'Problem / solution', 'Product demo'],
  saas: ['Workflow demo', 'Feature reveal', 'Customer outcome'],
  mobile: ['App walkthrough', 'Social proof', 'Pain-point hook'],
  finance: ['Benefit explainer', 'Product walkthrough', 'Trust signal'],
  education: ['Learning outcome', 'Instructor clip', 'Skill challenge'],
  travel: ['Destination reveal', 'Price comparison', 'Itinerary idea'],
};

const PLATFORMS = [
  ['Instagram', 'Facebook'],
  ['Instagram', 'Facebook', 'Messenger'],
  ['Instagram'],
  ['Facebook', 'Instagram'],
];

export const META_AD_BRANDS = META_AD_CATEGORIES.flatMap((category, categoryIndex) =>
  BRAND_GROUPS[category.id].map(([name, logo], brandIndex) => ({
    id: `${category.id}-${name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
    name,
    logo: logo ? `/brand-logos/${logo}` : null,
    category: category.id,
    accent: category.accent,
    curatedRank: brandIndex + 1,
    platforms: PLATFORMS[(categoryIndex + brandIndex) % PLATFORMS.length],
    angles: CREATIVE_ANGLES[category.id],
    metaUrl: `https://www.facebook.com/ads/library/?active_status=active&ad_type=all&country=US&q=${encodeURIComponent(name)}&search_type=keyword_unordered`,
  }))
);

export const categoryById = Object.fromEntries(META_AD_CATEGORIES.map((category) => [category.id, category]));
